export enum ScreenSize {
	DESKTOP = 'Desktop',
	TABLET = 'Tablet',
	MOBILE = 'Mobile'
}

export enum ThemeKind {
	LIGHT = 'light',
	DARK = 'dark'
}

export enum ThemeId {
	LIGHT = 'light-theme',
	SILVER = 'silver-theme',
	SOLARIZED_LIGHT = 'solarized-light-theme',
	LATTE = 'latte-theme',
	DARK = 'dark-theme',
	BUTTER = 'butter-theme',
	CARBON = 'carbon-theme',
	NORD = 'nord-theme',
	DRACULA = 'dracula-theme',
	GRUVBOX = 'gruvbox-theme',
	CATPPUCCIN = 'catppuccin-theme',
	TOKYO_NIGHT = 'tokyo-night-theme',
	ROSE_PINE = 'rose-pine-theme',
	SOLARIZED_DARK = 'solarized-dark-theme'
}

export enum MessageLayout {
	MODERN = 0,
	COMPACT = 1,
	BUBBLE = 2
}

export enum SettingsPage {
	GENERAL = 'general',
	ACCOUNT = 'account',
	NOTIFICATION = 'notification',
	DEVICES = 'devices',
	EMOJIS_STICKERS = 'emojis-stickers',
	DEVELOPER_TOOLS = 'developer-tools',
	ABOUT = 'about'
}

export enum RoomSettingsPage {
	GENERAL = 'general',
	MEMBERS = 'members',
	PERMISSIONS = 'permissions',
	EMOJIS_STICKERS = 'emojis-stickers',
	DEVELOPER_TOOLS = 'developer-tools'
}

export enum SpaceSettingsPage {
	GENERAL = 'general',
	MEMBERS = 'members',
	PERMISSIONS = 'permissions',
	EMOJIS_STICKERS = 'emojis-stickers',
	DEVELOPER_TOOLS = 'developer-tools'
}

export enum CreateRoomType {
	TEXT_ROOM = 'text',
	VOICE_ROOM = 'voice'
}

export enum CreateRoomAccess {
	PRIVATE = 'private',
	RESTRICTED = 'restricted',
	PUBLIC = 'public'
}
